(function () {
  'use strict';

  function copyText(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value);
    }
    var helper = document.createElement('textarea');
    helper.value = value;
    helper.setAttribute('readonly', '');
    helper.style.position = 'fixed';
    helper.style.opacity = '0';
    document.body.appendChild(helper);
    helper.select();
    var copied = document.execCommand('copy');
    helper.remove();
    return copied ? Promise.resolve() : Promise.reject(new Error('Copy failed'));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-copy-text]');
    if (!button) return;
    var status = document.querySelector('.hm-contact-copy-status');
    var originalLabel = button.textContent;
    copyText(button.getAttribute('data-copy-text'))
      .then(function () {
        button.textContent = 'Copied';
        if (status) status.textContent = 'Copied to clipboard.';
        window.setTimeout(function () { button.textContent = originalLabel; }, 1800);
      })
      .catch(function () {
        if (status) status.textContent = 'Copy failed. Please select the text and copy it manually.';
      });
  });
})();
